import { GiftIcon } from '@phosphor-icons/react'
import { useMediaQuery } from '@mui/material'

import { Button } from '@components/shared/Button'
import { currencyMask } from '@utils/masks/currencyMask'
import { emotionTheme } from '@styles/theme'

import type { BonusHighlightCardProps } from './types'

import * as S from './styles'

const EMPTY_VALUE = '-'

export const BonusHighlightCard = ({ data, isLoading, onSeeBonus }: BonusHighlightCardProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)

  const hasData = !!data && !isLoading

  const previewLabel = !data?.currentPreviewNumber ? 'Prévia' : `Prévia ${data.currentPreviewNumber}ª semana`
  const previewPercentage = hasData ? `${data.previewCurrentPercentage.toFixed(2)}%`.replace('.', ',') : EMPTY_VALUE
  const previewAmount = hasData ? currencyMask(data.previewCurrentAmount.toFixed(2)) : EMPTY_VALUE

  return (
    <S.Container>
      <S.Label>Bonificação</S.Label>

      <S.Content>
        <S.MetricBox>
          <S.IconBox>
            <GiftIcon size={24} />
          </S.IconBox>

          <S.MetricTexts>
            <S.MetricLabel>{previewLabel}</S.MetricLabel>

            <S.MetricValues>
              <S.PercentageValue>{previewPercentage}</S.PercentageValue>
              <S.Value>{previewAmount}</S.Value>
            </S.MetricValues>
          </S.MetricTexts>
        </S.MetricBox>

        <Button width={isMobile ? '100%' : 190} colorType="solidGreen" onClick={onSeeBonus}>
          Ver Bonificação
        </Button>
      </S.Content>
    </S.Container>
  )
}
